(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-override"] && !Shopify.designMode) return;
  try {
    window.addEventListener(
    'load',
    window.addEventListener('load', () => {
      const cookie = document.querySelector('.cc-settings');
      const link = document.querySelector("a[href='#cookie']");
      if (link) {
        link.addEventListener('click', (evt) => {
          evt.preventDefault();
          cookie.click();
        });
      }
    })
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lazyload"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const videos = Array.from(document.querySelectorAll('video.shopify-lazy-video'));

  // Step A: Disarm sources (move src -> data-src so nothing loads yet)
  videos.forEach(video => {
    // If <video> has a direct src, move it
    if (video.hasAttribute('src')) {
      video.dataset.src = video.getAttribute('src');
      video.removeAttribute('src');
    }
    // Move each <source src> to data-src
    video.querySelectorAll('source').forEach(source => {
      if (source.getAttribute('src')) {
        source.dataset.src = source.getAttribute('src');
        source.removeAttribute('src');
      }
    });
    // Reset the resource selection so nothing is fetched
    video.load();
  });

  // Step B: Observe and load on enter
  const loadVideo = (video) => {
    const sources = video.querySelectorAll('source[data-src]');
    if (sources.length) {
      sources.forEach(s => {
        s.setAttribute('src', s.dataset.src);
        s.removeAttribute('data-src');
      });
    } else if (video.dataset.src) {
      // Fallback if <video> had a direct src
      video.setAttribute('src', video.dataset.src);
      delete video.dataset.src;
    }
    video.load();

    // Optional auto-play when visible and allowed (muted + playsinline recommended)
    if (video.hasAttribute('autoplay') || video.dataset.autoplay === 'true') {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {/* ignore autoplay errors */});
      }
    }
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' }); // pre-load a bit before it’s visible

    videos.forEach(v => io.observe(v));
  } else {
    // Fallback: just load immediately
    videos.forEach(loadVideo);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('modal-dialog')) {
    customElements.define(
      'modal-dialog',
      class ModalDialog extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.openButton = document.querySelector('.localization-modal__open');
          this.closeButtons = this.querySelectorAll('.modal__button-toggle');
          this.closeButtons.forEach((button) => {
            button.addEventListener('click', () => this.close());
          });
          this.openButton?.addEventListener('click', () => {
            this.setAttribute('open', '');
          });
          this.addEventListener('click', (event) => {
            if (event.target === this) {
              this.close();
            }
          });
        }
        close() {
          this.removeAttribute('open');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
